import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import ProductCard from "../Cards/ProductCard.jsx";
import useWindowSize from "./useWindowSize.js";
import "./FeatProd.scss";

const FeaturedProduct = () => {
  const { allProducts } = useSelector((state) => state.products);

  const [itemsToShow, setItemsToShow] = useState(12);

  const { width } = useWindowSize();

  useEffect(() => {

    if (width <= 576) {
      setItemsToShow(4);
    } else if (width > 576 && width < 992) {
      setItemsToShow(8);
    } else if (width > 993 && width < 1990) {
      setItemsToShow(12);
    }
     else {
      setItemsToShow(16);
    }
  }, [width]);

  const newestProducts = useMemo(() => {
    if (!Array.isArray(allProducts)) return [];

    return [...allProducts]
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, itemsToShow);
  }, [allProducts, itemsToShow]);

  return (
    <div className="FeatProd">
      <div className="FeatProd__container">
        <div className="FeatProd__title">
          <h1>Рекомендовані продукти</h1>
        </div>
        <div className="FeatProd__grid">
          {newestProducts.map((product) => (
            <ProductCard data={product} key={product.id || product._id} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProduct;
